import { createFileRoute, Outlet, useChildMatches } from '@tanstack/react-router'

import { PedidoDeLink } from '@/components/gestor/recuperacao/PedidoDeLink'

/*
 * `/gestor/esqueci-senha`: tela pública (sem sessão) do pedido do link de senha.
 * A guarda da rota-mãe a deixa abrir por estar na lista de caminhos públicos.
 *
 * `/gestor/esqueci-senha/codigo` é filha deste caminho no roteador, então esta
 * rota também é a casca dela: com filha casada, mostra a filha (`Outlet`);
 * sem, o pedido de link.
 */
function EsqueciSenha() {
  const comFilha = useChildMatches().length > 0
  return comFilha ? <Outlet /> : <PedidoDeLink />
}

export const Route = createFileRoute('/gestor/esqueci-senha')({ component: EsqueciSenha })
